import { EditIcon, EyeIcon, TrashIcon } from "assets";
import {
  CustomTooltip,
  MediumScreenModel,
  SmallScreenModel,
  SwitchButton,
} from "components";
import React, { useState } from "react";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { FeaturedAdsStatusEnum, SpecialOfferStatus } from "props/enum";
// import HandleChangeStatus from "./HandleChangeStatus";
import { PreviewImage } from "./components/PreviewFeaturedAds";
import { SuperAdminStatusEnum } from '../../../props/enum';
import { SpecialOfferProps } from "../state/actionType";
import HandleUpdateSpecialOffer from "./HandleUpdateSpecialOffer";
import HandleChangeStatus from "./HandleChangeStatus";

const ActionButton: React.FC<{ items: SpecialOfferProps }> = ({ items }) => {
  const [isEditModel, setEditModel] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [isDeleteModel, setDeleteModel] = useState(false);
  const [isStatusModel, setStatusModel] = useState(false);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_FEATURED_ADS));
  if (isPermitted)
    return (
      <>
        <div className="flex flex-row gap-2 justify-center">
          <CustomTooltip title="Preview" placement="bottom">
            <button
              className="hover:text-primary-900"
              onClick={() => setIsPreview(true)}
            >
              <EyeIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Edit" placement="bottom">
            <button
              className="hover:text-primary-500"
              onClick={() => setEditModel(true)}
            >
              <EditIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Delete" placement="bottom">
            <button
              className="hover:text-red-500"
              onClick={() => setDeleteModel(true)}
            >
              <TrashIcon className="" />
            </button>
          </CustomTooltip>
          <CustomTooltip
            title={
              items.status === SpecialOfferStatus.Active
                ? SpecialOfferStatus.InActive
                : SpecialOfferStatus.Active
            }
            placement="bottom"
          >
            <button onClick={() => setStatusModel(true)}>
              <SwitchButton
                id={"status"}
                name={"status"}
                value={items.status === SpecialOfferStatus.Active}
                onChange={() => setStatusModel(true)}
              />
            </button>
          </CustomTooltip>
        </div>
        <MediumScreenModel setShowModal={setEditModel} showModal={isEditModel}>
          <HandleUpdateSpecialOffer
            specailOfferData={items}
            onClose={() => setEditModel(!isEditModel)}
          />
        </MediumScreenModel>
        <SmallScreenModel
          setShowModal={setDeleteModel}
          showModal={isDeleteModel}
        >
          <HandleUpdateSpecialOffer
            specailOfferData={items}
            onClose={() => setDeleteModel(!isDeleteModel)}
          />
        </SmallScreenModel>
        <SmallScreenModel
          setShowModal={setStatusModel}
          showModal={isStatusModel}
        >
          <HandleChangeStatus
            onClose={() => setStatusModel(!isStatusModel)}
            specailOfferData={items}
          />
        </SmallScreenModel>
        <SmallScreenModel setShowModal={setIsPreview} showModal={isPreview}>
          <PreviewImage specailOfferData={items} />
        </SmallScreenModel>
      </>
    );
  return <></>;
};

export default ActionButton;
